export const LIST_OVERSCAN = 8;

export const LIST_ITEM_HEIGHTS = {
  sm: 32,
  md: 40,
  lg: 48,
} as const;

export const LIST_ITEM_SELECTOR = '[data-slot="list-item"]';

export const LIST_NAVIGATION_KEYS = [
  "ArrowDown",
  "ArrowUp",
  "Home",
  "End",
] as const;
